import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { showNotification } from '../../../StatusNotification';
import { showConfirmation } from '../../../ConfirmationModal';

export class SingleFeatures1Form extends Component {
    static displayName = SingleFeatures1Form.name;

    constructor(props) {
        super(props);
        this.state = {
            singleFeatures1: null,
            htmlEditors: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newSingleFeatures1 = this.state.singleFeatures1;
        if (e.target.name == "htmlEditorId") {
            newSingleFeatures1[e.target.name] = parseInt(e.target.value, 10);
        }
        else {
            newSingleFeatures1[e.target.name] = e.target.value;
        }
        this.setState({ singleFeatures1: newSingleFeatures1 });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let singleFeatures1 = this.state.singleFeatures1;
        singleFeatures1.versionId = this.state.versionId;
        singleFeatures1.pageId = this.state.pageId;
        let url = this.state.formType == "Update" ? "UpdateSingleFeatures1" : "CreateSingleFeatures1";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(singleFeatures1),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                    var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "SingleFeatures1", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    
                    //window.location = '/UpdatePageComponent/' + this.state.pageId;
                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        let htmlEditorOptions = [];
        let selectedId = null;
        let componentName = null;

        htmlEditorOptions.push(<option value="" key="htmlEditor0">--Select--</option>);
        if (this.state.singleFeatures1 != null && this.state.htmlEditors != null) {
            let singleFeatures1 = this.state.singleFeatures1;
            selectedId = singleFeatures1.htmlEditorId;
            componentName = singleFeatures1.componentName;
            for (var i = 0; i < this.state.htmlEditors.length; i++) {
                let htmlEditor = this.state.htmlEditors[i];
                if (htmlEditor.pageId == this.state.pageId) {
                    let htmlEditorKey = "htmlEditor" + (i + 1);

                    let ddlDisplay = htmlEditor.componentName != null ? htmlEditor.componentName + "-V" + htmlEditor.versionId : htmlEditor.content.substring(0, 100) + "-V" + htmlEditor.versionId;
                    htmlEditorOptions.push(<option value={htmlEditor.id} key={htmlEditorKey}>{ddlDisplay}</option>);
                }
            }
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <form onSubmit={this.handleSubmit} className={wrapperClasses}>
                <div className='dual-grid'>
                    <div className='dual-grid__1-2 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('SingleFeatures1')}</h2>
                    </div>

                    <label htmlFor='singleFeatures1-componentName'>Component Name:</label>
                    <input id='singleFeatures1-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />

                    <label htmlFor='singleFeatures1-htmlEditorId'>Html Editor: </label>
                    <select id='singleFeatures1-htmlEditorId' name='htmlEditorId' value={selectedId} onChange={this.handleChange} required>
                        {htmlEditorOptions}
                    </select>

                    <div className='dual-grid__1-2'>
                        <button type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetSingleFeatures1?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            singleFeatures1: data.singleFeatures1,
            htmlEditors: data.htmlEditors,
            formType: formType
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteSingleFeatures1?componentId=' + this.state.singleFeatures1.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                //window.location = '/UpdatePageComponent/' + this.state.pageId;
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default SingleFeatures1Form;
